module.exports = __webpack_public_path__ + "static/media/audio3.3032beac.wav";